<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter BookTitlePage" id="section_booktitlepage--num_1--seq_3"><div class="title-block-book"><h1>MISTRESS <br/> BELOW DECK</h1> <p class="title-author">Helen Dickson</p></div> <div class="imprint"><p><img alt="alt" src="new_mab002_logo.jpg"/></p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781408913727_booktitlepage.vue?162f6ea4